var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { Modal, Button, Input, Space, message, Typography, Tooltip } from "antd";
import { ShareAltOutlined, XOutlined, WhatsAppOutlined, CopyOutlined, FacebookFilled, LinkedinFilled } from "@ant-design/icons";
import "./Share.scss";
var Text = Typography.Text;
var PLATFORM_CONFIG = {
    x: {
        label: "X",
        icon: _jsx(XOutlined, {}),
        color: "#000000",
        buildUrl: function (url, title) { return "https://x.com/intent/tweet?url=".concat(encodeURIComponent(url), "&text=").concat(encodeURIComponent(title)); }
    },
    facebook: {
        label: "Facebook",
        icon: _jsx(FacebookFilled, {}),
        color: "#1877F2",
        buildUrl: function (url) { return "https://www.facebook.com/sharer/sharer.php?u=".concat(encodeURIComponent(url)); }
    },
    linkedin: {
        label: "LinkedIn",
        icon: _jsx(LinkedinFilled, {}),
        color: "#0A66C2",
        buildUrl: function (url) { return "https://www.linkedin.com/sharing/share-offsite/?url=".concat(encodeURIComponent(url)); }
    },
    whatsapp: {
        label: "WhatsApp",
        icon: _jsx(WhatsAppOutlined, {}),
        color: "#25D366",
        buildUrl: function (url, title) { return "https://api.whatsapp.com/send?text=".concat(encodeURIComponent("".concat(title, " ").concat(url))); }
    }
};
var DEFAULT_PLATFORMS = ["x", "facebook", "linkedin", "whatsapp"];
function openSharePopup(url) {
    var width = 600;
    var height = 500;
    var left = window.screenX + (window.outerWidth - width) / 2;
    var top = window.screenY + (window.outerHeight - height) / 2;
    window.open(url, "share-popup", "width=".concat(width, ",height=").concat(height, ",left=").concat(left, ",top=").concat(top));
}
var ShareComponent = function (_a) {
    var url = _a.url, _b = _a.title, title = _b === void 0 ? "" : _b, _c = _a.triggerText, triggerText = _c === void 0 ? "Share" : _c, _d = _a.modalTitle, modalTitle = _d === void 0 ? "Share" : _d, _e = _a.socialSectionLabel, socialSectionLabel = _e === void 0 ? "Share directly to your channels:" : _e, _f = _a.copySectionLabel, copySectionLabel = _f === void 0 ? "Or copy the direct link:" : _f, _g = _a.copySuccessMessage, copySuccessMessage = _g === void 0 ? "Link copied to clipboard!" : _g, _h = _a.platforms, platforms = _h === void 0 ? DEFAULT_PLATFORMS : _h, triggerButtonProps = _a.triggerButtonProps, onCopy = _a.onCopy, onShare = _a.onShare, _j = _a.width, width = _j === void 0 ? 450 : _j, _k = _a.iconOnly, iconOnly = _k === void 0 ? false : _k, _l = _a.usePrimaryColor, usePrimaryColor = _l === void 0 ? false : _l;
    var _m = useState(false), isModalOpen = _m[0], setIsModalOpen = _m[1];
    var resolveUrl = function () { return url !== null && url !== void 0 ? url : (typeof window !== "undefined" ? window.location.href : ""); };
    var handleCopy = function () { return __awaiter(void 0, void 0, void 0, function () {
        var shareUrl, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    shareUrl = resolveUrl();
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, navigator.clipboard.writeText(shareUrl)];
                case 2:
                    _b.sent();
                    message.success(copySuccessMessage);
                    onCopy === null || onCopy === void 0 ? void 0 : onCopy(shareUrl);
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    message.error("Unable to copy the link.");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleShare = function (platform) {
        var shareUrl = resolveUrl();
        openSharePopup(PLATFORM_CONFIG[platform].buildUrl(shareUrl, title));
        onShare === null || onShare === void 0 ? void 0 : onShare(platform, shareUrl);
    };
    return (_jsxs(_Fragment, { children: [_jsx(Button, __assign({ type: "primary", icon: _jsx(ShareAltOutlined, {}), onClick: function () { return setIsModalOpen(true); }, className: "share-button__btn" }, triggerButtonProps, { children: triggerText })), _jsx(Modal, __assign({ title: modalTitle, open: isModalOpen, onCancel: function () { return setIsModalOpen(false); }, footer: null, centered: true, width: width }, { children: _jsxs("div", __assign({ style: { padding: "10px 0" } }, { children: [platforms.length > 0 && (_jsxs(_Fragment, { children: [_jsx(Text, __assign({ type: "secondary", style: { display: "block", marginBottom: 12 } }, { children: socialSectionLabel })), _jsx(Space, __assign({ size: "middle", wrap: true, style: { width: "100%", justifyContent: "center", marginBottom: 24 } }, { children: platforms.map(function (platform) {
                                        var config = PLATFORM_CONFIG[platform];
                                        var shareButton = (_jsx(Button, __assign({ type: "primary", shape: iconOnly ? "circle" : undefined, icon: config.icon, onClick: function () { return handleShare(platform); }, "aria-label": config.label, style: usePrimaryColor ? undefined : { backgroundColor: config.color, borderColor: config.color } }, { children: !iconOnly && config.label })));
                                        return iconOnly ? (_jsx(Tooltip, __assign({ title: config.label }, { children: shareButton }), platform)) : (_jsx(React.Fragment, { children: shareButton }, platform));
                                    }) }))] })), _jsx(Text, __assign({ type: "secondary", style: { display: "block", marginBottom: 8 } }, { children: copySectionLabel })), _jsx(Input, { value: resolveUrl(), readOnly: true, addonAfter: _jsx(Button, { type: "text", size: "small", icon: _jsx(CopyOutlined, {}), onClick: handleCopy, style: { margin: "-4px -11px" } }) })] })) }))] }));
};
export default ShareComponent;
